import PropTypes from "prop-types";
import { useCallback } from "react";
import { sendTagOnMerchandisingButtonClick } from "app/utils/analytics";
import RelativeLink from "app/pages/.shared/RelativeLink";
import "./Merchandising.scss";
import { stringify } from "qs";
import Countdown from "react-countdown-now";
import MerchCountdown from "app/pages/.shared/MerchCountdown/MerchCountdown";
import IconExternalLink from "app/pages/.shared/IconExternalLink";
import { connect } from "react-redux";
import { getMerchPreviewStartDate } from "app/pages/Merchandising/merchandisingSelector";
import { zonedTimeToUtc } from "date-fns-tz";

export const Merchandising = ({
	merchandisingCode,
	forceClickOnPicture = false,
	ctaButtonText,
	ctaButtonColor,
	ctaButtonBackgroundColor,
	imageElement,
	countdownPosition,
	countdownTextColor,
	countdownStartAt,
	countdownEndAt,
	daysInHours,
	endAt,
	redirectUrl,
	position,
	indexCarousel,
	previewStartDate,
}) => {
	const handleMerchClick = useCallback(() => {
		sendTagOnMerchandisingButtonClick(merchandisingCode, position, indexCarousel);
	}, [merchandisingCode, position, indexCarousel]);

	const now = Date.now();
	const countdownStartDate = new Date(countdownStartAt).getTime();
	const countdownEndDate = new Date(countdownEndAt).getTime();

	const previewDateTimestamp = zonedTimeToUtc(previewStartDate, "YYYYMMDD");
	const shouldPreviewCountdown =
		previewDateTimestamp &&
		previewDateTimestamp >= countdownStartDate &&
		previewDateTimestamp < countdownEndDate;

	const displayCountdown =
		countdownPosition &&
		(shouldPreviewCountdown ||
			(countdownStartAt &&
				now >= countdownStartDate &&
				(!countdownEndAt || now < countdownEndDate)));

	const to = redirectUrl
		? {
				pathname: redirectUrl,
		  }
		: {
				pathname: "/merch",
				search: `?${stringify({ code: merchandisingCode })}`,
		  };

	const openNewTab =
		merchandisingCode === "TRAVELDOR" ||
		merchandisingCode === "LRETMOI" ||
		merchandisingCode === "ANNIVERSAIRE" ||
		merchandisingCode === "CLUBMED" ||
		redirectUrl;

	const disableMerchRedirection =
		merchandisingCode === "PAIEMENT4X" || merchandisingCode === "SMARTCODES";

	let countdownStyle = "center";

	if (countdownPosition === "top") {
		countdownStyle = "flex-start";
	} else if (countdownPosition === "bottom") {
		countdownStyle = "flex-end";
	}
	const showCta = ctaButtonText && !disableMerchRedirection;

	return (
		<div className="merchandising">
			<RelativeLink
				style={{
					// cas ou les merchandising est dans un carrousel ou le slide viendrait rediriger vers la page merchandising
					pointerEvents: !forceClickOnPicture && !showCta ? "none" : "auto",
				}}
				to={to}
				onClick={handleMerchClick}
				target={openNewTab ? "_blank" : ""}
			>
				{imageElement}
				{displayCountdown && (
					<div
						className="merchandising__countdown"
						style={{ justifyContent: countdownStyle, color: countdownTextColor }}
					>
						<Countdown
							daysInHours={daysInHours}
							date={endAt}
							zeroPadTime={2}
							zeroPadDays={2}
							renderer={({ formatted: { days, hours, minutes, seconds } }) => (
								<MerchCountdown
									days={days}
									hours={hours}
									seconds={seconds}
									minutes={minutes}
								/>
							)}
						/>
					</div>
				)}
			</RelativeLink>
			{showCta && (
				<div className="merchandising__cta">
					<RelativeLink
						target={openNewTab ? "_blank" : ""}
						style={{
							color: ctaButtonColor,
							backgroundColor: ctaButtonBackgroundColor,
						}}
						to={to}
						variant="primary"
						disabled={disableMerchRedirection}
						onClick={handleMerchClick}
					>
						{ctaButtonText}
						{redirectUrl && <IconExternalLink />}
					</RelativeLink>
				</div>
			)}
		</div>
	);
};

Merchandising.propTypes = {
	forceClickOnPicture: PropTypes.bool,
	imageElement: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
	ctaButtonText: PropTypes.string,
	ctaButtonColor: PropTypes.string,
	ctaButtonBackgroundColor: PropTypes.string,
	merchandisingCode: PropTypes.string,
	position: PropTypes.number,
	indexCarousel: PropTypes.number,
	countdownPosition: PropTypes.string,
	countdownTextColor: PropTypes.string,
	countdownStartAt: PropTypes.string,
	countdownEndAt: PropTypes.string,
	daysInHours: PropTypes.bool,
	endAt: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	redirectUrl: PropTypes.string,
	previewStartDate: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		previewStartDate: getMerchPreviewStartDate(state),
	};
};

export default connect(mapStateToProps)(Merchandising);
